export default "__VITE_ASSET__def8383a__"